"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTabList = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
// TODO: remove TO BE REMOVED styles when responsive dropdown is added
exports.StyledTabList = styled_components_1.default.ul `
    padding-left: 0;
    margin: 0;
    list-style: none;
    display: flex;

    /* TO BE REMOVED WHEN RESPONSIVE DROPDOWN IS ADDED */
    overflow-x: auto;
    height: initial;

    &::-webkit-scrollbar {
        height: 6px;
        width: 6px;
        border: 1px solid $greyscale-white;
    }

    &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 3px rgb(0 0 0 / 30%);
        border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 3px rgb(0 0 0 / 50%);
    }
    /* END * TO BE REMOVED WHEN RESPONSIVE DROPDOWN IS ADDED */
`;
//# sourceMappingURL=TabList.styles.js.map